import { combineReducers } from 'redux';

import creativesReducer, { INITIAL_STATE as CREATIVES_INITIAL_STATE } from './creatives';
import * as fromCreatives from './creatives/selectors';
import { get as getGraphicPromo, getAll as getAllGraphicPromos } from './graphicPromos/selectors';
import { get as getHomepageHero, getAll as getAllHomepageHeroes } from './homepageHeroes/selectors';
import {
  getAll as getAllHomepageVideos,
  get as getHomepageVideo,
} from './homepageVideos/selectors';
import navCardReducer, { INITIAL_STATE as NAV_CARD_INITIAL_STATE } from './navCard';
import * as fromNavCard from './navCard/selectors';

import type { Status } from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/adverts';
import type {
  GraphicPromo,
  GraphicPromoById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/graphicPromo';
import type {
  HomepageHero,
  HomepageHeroById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageHero';
import type {
  HomepageVideo,
  HomepageVideoById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/homepageVideo';
import type {
  NavCard,
  NavCardById,
} from '@web-platform/shared-universal-types/src/redux/banana/state/combinedResults/entitiesSearchResults/adverts/navCard';
import type { HomepageAdvertsState } from '@web-platform/shared-universal-types/src/redux/state/shared/adverts';

export const INITIAL_STATE: HomepageAdvertsState = {
  navCard: NAV_CARD_INITIAL_STATE,
  creatives: CREATIVES_INITIAL_STATE,
};

const homepageAdvertsReducer = combineReducers({
  navCard: navCardReducer,
  creatives: creativesReducer,
});

export default homepageAdvertsReducer;

// Base selectors
export const getNavCardAdvert = (state: HomepageAdvertsState, id: string): NavCard =>
  fromNavCard.get(state.navCard, id);

export const getAllNavCardAdverts = (state: HomepageAdvertsState): NavCardById =>
  fromNavCard.getAll(state.navCard);

export const getCreativesStatus = (state: HomepageAdvertsState): Status =>
  fromCreatives.getStatus(state.creatives);

export const getGraphicPromoAdvert = (state: HomepageAdvertsState, id: string): GraphicPromo =>
  getGraphicPromo(state.creatives.graphicPromos, id);

export const getAllGraphicPromoAdverts = (state: HomepageAdvertsState): GraphicPromoById =>
  getAllGraphicPromos(state.creatives.graphicPromos);

export const getHomepageHeroAdvert = (state: HomepageAdvertsState, id: string): HomepageHero =>
  getHomepageHero(state.creatives.homepageHeroes, id);

export const getAllHomepageHeroAdverts = (state: HomepageAdvertsState): HomepageHeroById =>
  getAllHomepageHeroes(state.creatives.homepageHeroes);

export const getHomepageVideoAdvert = (state: HomepageAdvertsState, id: string): HomepageVideo =>
  getHomepageVideo(state.creatives.homepageVideos, id);

export const getAllHomepageVideoAdverts = (state: HomepageAdvertsState): HomepageVideoById =>
  getAllHomepageVideos(state.creatives.homepageVideos);
